import { reactive } from "vue";

export const snackbar = reactive({
  visible: false, // Controls visibility of the snackbar
  message: "", // The text content of the snackbar. error response can be directly assigned here
  color: "info", // Optional: Set color (e.g., success, error, etc.)
  showClose: false, // Optional: Show close button
  timeout: "5000", // How long the snackbar is visible (in ms)
  icon: "", // Optional: Set vuetify icon (e.g., mdi-check-circle)
});

export const showSnackbar = (options) => {
  snackbar.message = options.message.response?.data?.error?.message || options.message;
  snackbar.color = options.color || "info";
  snackbar.visible = true;
  snackbar.showClose = false;
  snackbar.icon = options.icon || "";

  if (options.timeout) {
    snackbar.timeout = options.timeout;
  } else if (options.color === "error") {
    snackbar.timeout = "-1"; // open forever
  } else {
    snackbar.timeout = "5000"; // default
  }

  if (snackbar.timeout === "-1") {
    // show close button when snackbar is open forever
    snackbar.showClose = true;
  }
};

export const closeSnackbar = (options) => {
  snackbar.visible = false;
};
